import { render, staticRenderFns } from "./VerifyYou.vue?vue&type=template&id=24e8d32b&scoped=true"
import script from "./VerifyYou.vue?vue&type=script&lang=js"
export * from "./VerifyYou.vue?vue&type=script&lang=js"
import style0 from "./VerifyYou.vue?vue&type=style&index=0&id=24e8d32b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_react-dom@19.2.4_react@18.3.1_vue-templat_zb2mrinni5lndihrytzfraeym4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8d32b",
  null
  
)

export default component.exports